export default "__VITE_ASSET__D5El6PqX__"